module.exports = __webpack_public_path__ + "static/media/redDownArrow.673d3046.svg";